import { defineMessages } from 'react-intl';

import { DOSSIER_CREATE_PATH_TYPES } from './dossierCreate.types';

const messages = defineMessages({
  title: {
    id: 'dossierCreateDrawer.title',
    defaultMessage: 'Créer un dossier',
  },
  choosePath: {
    id: 'dossierCreateDrawer.choosePath',
    defaultMessage: 'Choisir un parcours',
  },
  selectedPath: {
    id: 'dossierCreateDrawer.selectedPath',
    defaultMessage: 'Parcours sélectionné :',
  },
  back: {
    id: 'dossierCreateDrawer.back',
    defaultMessage: '← Retour',
  },
  integrationHint: {
    id: 'dossierCreateDrawer.integrationHint',
    defaultMessage:
      'Ce parcours responsive sera branché ici. Le flux de création existant s’affichera dans ce drawer.',
  },
  [DOSSIER_CREATE_PATH_TYPES.NUMERO_COMMANDE]: {
    id: 'dossierCreateDrawer.path.numeroCommande',
    defaultMessage: 'Numéro de commande',
  },
  [DOSSIER_CREATE_PATH_TYPES.INFO_PRODUIT]: {
    id: 'dossierCreateDrawer.path.infoProduit',
    defaultMessage: 'Info produit',
  },
  [DOSSIER_CREATE_PATH_TYPES.CODE_BARRES]: {
    id: 'dossierCreateDrawer.path.codeBarres',
    defaultMessage: 'Code-barres / n° de série',
  },
  [DOSSIER_CREATE_PATH_TYPES.RECHERCHE_CLIENT]: {
    id: 'dossierCreateDrawer.path.rechercheClient',
    defaultMessage: 'Recherche client',
  },
  pathHintNumeroCommande: {
    id: 'dossierCreateDrawer.pathHint.numeroCommande',
    defaultMessage:
      'Recherche par numéro de commande : saisie, scan ou sélection dans la liste des commandes.',
  },
  pathHintInfoProduit: {
    id: 'dossierCreateDrawer.pathHint.infoProduit',
    defaultMessage:
      'Identification du produit : référence, marque, modèle ou scan du code produit.',
  },
  pathHintCodeBarres: {
    id: 'dossierCreateDrawer.pathHint.codeBarres',
    defaultMessage:
      'Scan ou saisie d’un code-barres / numéro de série pour retrouver le produit concerné.',
  },
  pathHintRechercheClient: {
    id: 'dossierCreateDrawer.pathHint.rechercheClient',
    defaultMessage:
      'Recherche du client par nom, e-mail ou téléphone avant d’ouvrir le dossier.',
  },
});

export default messages;
